import PropTypes from 'prop-types'
import React from 'react'

export default function Prompt({ message, options, onSelectOption }) {
  return (
    <div className="Prompt component">
      <div className="container">
        {message}
        <div className="actions">
          {options.map((option, index) => (
            <button onClick={() => onSelectOption(index, option)} key={index}>
              {option.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

Prompt.propTypes = {
  message: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onSelectOption: PropTypes.func.isRequired,
}
